import { CropOriginal } from '@mui/icons-material';
import React, { createContext, useContext, useEffect, useState } from 'react';

const CheckboxContext = createContext();

export const useCheckboxContext = () => useContext(CheckboxContext);

export const CheckboxProvider = ({ children }) => {
    const [checkedItems, setCheckedItems] = useState({});
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [CurrentPageItems, setCurrentPageItems] = useState([]);
    const [isCheck, setIsCheck] = useState([]);
    const [isCheckExportedRows, setIsCheckExportedRows] = useState([]);
    const toggleCheckbox = (e, data) => {
        const { id, checked } = e.target;
        setCheckedItems((prev) => {
            const newCheckedItems = {
                ...prev,
                [id]: !prev[id],
            };
            setIsCheck([...isCheck, id.toString()]);

            // let newList = [...isCheckExportedRows, data.filter(x => x.id.toString() == id)]
            // setIsCheckExportedRows(newList);

            let tempCheckboxExportedRows = data.filter(x => x.id.toString() == id);
            let combinedExportedRows = [...isCheckExportedRows, ...tempCheckboxExportedRows];
            const uniqueExportedRowsSet = new Set(combinedExportedRows);            
            const uniqueExportedRowsList = [...uniqueExportedRowsSet];
            setIsCheckExportedRows(uniqueExportedRowsList)

            




            if (!checked) {
                setIsCheck(isCheck.filter(item => item.toString() !== id));
                setIsCheckExportedRows(uniqueExportedRowsList.filter(x => x.id.toString() !== id));
            }
            return newCheckedItems;
        });
    };

    const toggleSelectAll = (items) => {
        const newCheckedItems = {};
        // setCurrentPageItems(items);

        items.forEach(item => {
            newCheckedItems[item.id] = !isCheckAll;
        });

        setIsCheckAll(!isCheckAll);


        if (!isCheckAll) {
            let tempCheckboxList = items.map(item => item?.id?.toString());
            let combinedList = [...isCheck, ...tempCheckboxList];

            const uniqueSet = new Set(combinedList);
            // Convert the Set back to an array
            const uniqueList = [...uniqueSet];
            // Create a Set to remove duplicates

            setIsCheck(uniqueList);
            /* Begin ExportedRows */
            let tempCheckboxExportedRows = items;
            let combinedExportedRows = [...isCheckExportedRows, ...tempCheckboxExportedRows];
            const uniqueExportedRowsSet = new Set(combinedExportedRows);            
            const uniqueExportedRowsList = [...uniqueExportedRowsSet];
            setIsCheckExportedRows(uniqueExportedRowsList)

            setCheckedItems(uniqueList);// new

        }
        else {
            let result = CurrentPageItems.map(x => x?.id?.toString());
            const newList = isCheck?.filter(item => !result.includes(item));
            setIsCheck(newList);
            setIsCheckExportedRows(isCheckExportedRows.filter(x => !result.includes(x?.id?.toString())));

            setCheckedItems(newList);// new
        }
    };



    const reConfigureCheckboxes = (items) => {
        setCurrentPageItems(items);
    }

    useEffect(() => {
        let currentItems = CurrentPageItems.map(item => item.id.toString());
        let currentItemsCount = currentItems.length;
        //console.log('currentPageItems:::::' + JSON.stringify(currentItems))
        //console.log('itemsCount::::' + currentItemsCount)


        let currentChecks = isCheck; //isCheck.filter(element => currentItems.includes(element));
        setCheckedItems(currentChecks);
        let isCheckCount = countMatches(currentItems, currentChecks);
        //console.log('currentChecks:::::' + JSON.stringify(currentChecks))
        //console.log('isCheckCount:::::' + isCheckCount)

        setIsCheck(currentChecks);
        if (isCheckCount == currentItemsCount && currentItemsCount > 0 && isCheckCount > 0) {
            setIsCheckAll(true);
        }
        else {
            setIsCheckAll(false);
        }
        // let newlist = isCheck.map(item => {

        //     return CurrentPageItems.filter(x => x.id.toString() == item)
        // })
        // setIsCheckExportedRows(newlist);

         //console.log('x:::::' + JSON.stringify(newlist))
        //setIsCheckExportedRows([...isCheckExportedRows, ...isCheck]);
    }, [isCheck, isCheckAll, reConfigureCheckboxes]);

    const countMatches = (mainList, subList) => {
        return subList?.filter(item => mainList.includes(item)).length;
    };
    return (
        <CheckboxContext.Provider value={{ setCurrentPageItems, checkedItems, toggleCheckbox, toggleSelectAll, isCheckAll, setIsCheckAll, isCheck, reConfigureCheckboxes, isCheckExportedRows, setIsCheckExportedRows, setIsCheck }}>
            {children}
        </CheckboxContext.Provider>
    );
};